import type { IconData } from '@stacksjs/iconify-core'

export const compress: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M144 144H16v32h160V16h-32zm224 0V16h-32v160h160v-32zm-32 352h32V368h128v-32H336zM16 368h128v128h32V336H16z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default compress
